module.exports = [["1","Montag"],["2","Dienstag"],["3","Mittwoch"],["4","Donnerstag"],["5","Freitag"],["6","Samstag"],["7","Sonntag"]]


//////////////////
// WEBPACK FOOTER
// ./src/pages/Helpers/Storage/DayOfWeek.json
// module id = 228
// module chunks = 0